import ComparisonArea from './ComparisonArea.vue'

export default ComparisonArea
